export const objectToMap = <K extends string, V>(obj: Record<K, V>): Map<K, V> => {
  const map = new Map<K, V>();
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      map.set(key as K, obj[key]);
    }
  }
  return map;
};
